module.exports = __webpack_public_path__ + "static/media/app_store.341b206a.svg";